<!-- 入驻页-加盟商入驻-认证信息-结果 -->
<template>
	<div class="wrap">

		<div class="header-sub">
			<div class="header-sub-middle">
				<div class="header-top">
					<img @click="$router.push('/')" src="../assets/logo-3.png" class="logo-img">
				</div>

			</div>
		</div>

		<p class="top-title">加盟商入驻申请</p>

		<div class="middle-container">
			<div class="form">

				<div class="process-wrap">
					<div class="process active">
						<span class="process-label">验证手机号</span>
						<span class="circle border">1</span>
					</div>
					<div class="process active">
						<span class="process-label">企业认证</span>
						<span class="circle border">2</span>
					</div>
					<div class="process active">
						<span class="process-label">订购服务</span>
						<span class="circle bg">3</span>
					</div>
				</div>
				
				<!-- 银联支付 -->
				<div class="pay-box">
					<p class="amount-payable-row">
						应付金额：<span class="amount-payable-price">¥<span>9998</span></span>
					</p>
					<img src="../assets/pay-6.png" class="pay-icon">
					<span class="pay-msg">点击跳转第三方支付页面</span>
					<button type="button" class="pay-btn">暂未完成支付</button>
				</div>
				
					
				<!-- 支付成功显示 -->
				<!-- <div class="result-box">
					<img src="../assets/icon-success.png">支付成功
				</div> -->
				<!-- 支付失败显示 -->
			<!-- 	<div class="result-box">
					<img src="../assets/icon-fail.png">未检测到付款
				</div> -->
				
				
				
				<!-- 支付成功显示 -->
				<div class="center-btn-box">
					<div class="btn-box" style="justify-content: center;">
						<button type="button"   @click="$router.push('/index')">返回首页</button>
					</div>
				</div>
				<!-- 支付失败显示 -->
				<div class="center-btn-box">
					<div class="btn-box" style="justify-content: center;">
						<button type="button" class="border-btn"   @click="$router.push('/entry-enterprise-certification-information-company')">上一步</button>
						<button type="button">重新支付</button>
					</div>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				name: '',
				num: '',
				region: '',
				banknum: '',
			};
		},
		mounted() {},
		methods: {},
	};
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 137px;
		background-color: #FFFFFF;
	}

	.header-sub {
		width: 100%;
		height: 139px;
		background-color: #F8F5ED;
		position: fixed;
		top: 44px;
		left: 0;
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.header-sub-middle {
		width: 1200px;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 75px 0 35px;
		box-sizing: border-box;
	}

	.header-top {
		width: 100%;
		height: 130px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.logo-img {
		width: 224px;
	}

	.footer {
		width: 100%;
		height: 271px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.footer-middle {
		width: calc(1200px - 292px);
		display: flex;
		flex-direction: column;
	}

	.footer-tag-list {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-tag-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.footer-tag-icon {
		width: 56px;
		margin-bottom: 14px;
	}

	.footer-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 8px;
		box-sizing: border-box;
		margin-top: 37px;
	}

	.footer-bottom-left {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 135px;
	}

	.footer-bottom-left-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.footer-bottom-left-list>li {
		width: 33.3333%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-size: 16px;
		font-weight: bold;
		margin-top: 15px;
	}

	.footer-bottom-left-list>li:first-child,
	.footer-bottom-left-list>li:nth-child(2),
	.footer-bottom-left-list>li:nth-child(3) {
		margin-top: 0;
	}

	.footer-bottom-right {
		display: flex;
		align-items: center;
	}

	.footer-bottom-right-img {
		width: 48px;
		margin-right: 7px;
	}

	.footer-bottom-right-row {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.footer-font1 {
		color: #C69236;
		font-size: 28px;
		font-weight: bold;
	}

	.footer-font2 {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.middle-container {
		width: 1200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.form-row {
		width: 420px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 30px;
	}

	.form-label {
		width: 170px;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-right: 5px;
		box-sizing: border-box;
	}

	.form-input-box {
		flex: 1;

	}

	.form {
		width: 707px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 40px 0;
	}

	>>>.el-input__inner {
		border-radius: 8px !important;
		border: 1px solid #666666 !important;
		color: #606266 !important;
		height: 30px !important;
		line-height: 30px !important;
	}

	>>>.el-input__inner::placeholder {
		color: #999999 !important;
	}

	.upload-wrap {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.upload-module {
		display: flex;
		align-items: flex-start;
		margin-right: 60px;
	}

	.upload-module:last-child {
		margin-right: 0;
	}

	.upload-label {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.upload-box {
		width: 208px;
		height: 135px;
	}

	.upload-img {
		width: 100%;
		height: 100%;
	}

	.btn-box {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 75px 0 33px;
	}

	.btn-box>button {
		width: 152px;
		height: 36px;
		line-height: 36px;
		background-color: #FF6619;
		border-radius: 8px;
		color: #FFFFFF;
		font-size: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 14px;
		box-sizing: border-box;
	}

	.btn-box>button:last-child {
		margin-right: 0;
	}

	.btn-box>button.border-btn {
		border: 1px solid #666666;
		color: #666666;
		background-color: #EEEEEE;
	}

	.top-title {
		width: 100%;
		height: 50px;
		line-height: 50px;
    /*background: linear-gradient(180deg, #F3DC99, #F0AE46);*/
    background: #FFEC8B;
		font-size: 24px;
		font-weight: bold;
		/*color: #FFFFFF;*/
    color: #CD3333;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.process-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 34px;
	}

	.process {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	.process::after {
		content: "";
		position: absolute;
		left: calc(50% + 18px);
		bottom: 18px;
		width: calc(100% - 36px);
		height: 2px;
		background-color: #FF6619;
	}

	.process:last-child::after {
		background-color: initial;
	}

	.process-label {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 12px;
	}

	.circle {
		width: 36px;
		height: 36px;
		line-height: 36px;
		border: 2px solid #999999;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 20px;
		font-weight: bold;
		color: #999999;
		box-sizing: border-box;
	}

	.circle.border {
		border: 2px solid #FF6619;
		color: #F37C3D;
	}

	.circle.bg {
		background-color: #FF6619;
		color: #FFFFFF;
		border: none;
	}

	.process.active .process-label {
		color: #FF6619;
	}

	>>>.el-input__icon {
		line-height: 30px !important;
	}

	.result-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
		padding: 70px 0 20px;
	}

	.result-box>img {
		width: 72px;
		margin-bottom: 12px;
	}

	.center-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.pay-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 50px 0;
	}
	
	.amount-payable-row {
		color: #333333;
		font-size: 16px;
		margin-bottom: 35px;
	}
	
	.amount-payable-price {
		color: #D43634;
		font-size: 16px;
	}
	
	.amount-payable-price>span {
		font-size: 26px;
		font-weight: bold;
	}
	
	.pay-icon {
		width: 196px;
		margin-bottom: 6px;
	}
	
	.pay-msg {
		color: #333333;
		font-size: 12px;
	}
	
	.pay-btn {
		color: #666666;
		font-size: 16px;
		width: 152px;
		height: 36px;
		line-height: 36px;
		background-color: #EEEEEE;
		border: 1px solid #666666;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 70px;
	}
</style>
